export default (initialState = {}) => {
  return () => {
    return {
      grade: null,
      outcome: "",
      remarks: "",
      reason: "",
      ...initialState,
    };
  };
};
